export const STREAMLINE_LABELS = {
	title: 'Simplify and Streamline Product Discovery',
	section1:
		'Beacon Discovery is your year-round tool for finding innovative, high-quality natural products. Between events or ahead of a show, Beacon offers up-to-date product info, smart search tools, and curated insights. When it’s time for Natural Products Expo or Newtopia Now, it helps you research brands, build a must-see list, and navigate the floor with ease.',
	section2:
		'Created by New Hope Network, Beacon equips retailers with the tools they need to plan strategically—before they even step onto the show floor. And in 2025, the platform includes more product data than ever before, integrating your favorited products with the show floor maps for blue-dot navigation at events.',
	videoLink: '1084690378',
	videoHash: 'f1e38d7fdf',
	buttonText: 'Start Discovering'
};
